import React, { useRef, useEffect, SVGProps } from "react";
import { Box, Typography } from "@mui/material";

import { Shape, Canvas } from "types";
import { drawShapes } from "utility/whiteboard";
import { DEFAULT_CANVAS_HEIGHT, DEFAULT_CANVAS_WIDTH } from "utility";

interface CanvasItemProps extends SVGProps<SVGSVGElement> {
  canvas: Canvas;
  shapes: Shape[] | undefined;
  active?: boolean;
}

export const CanvasItem: React.FC<CanvasItemProps> = ({
  canvas,
  shapes,
  active = true,
  ...rest
}) => {
  const ref = useRef<SVGSVGElement>(null);

  const scale = {
    x: DEFAULT_CANVAS_WIDTH / Number(canvas.width),
    y: DEFAULT_CANVAS_HEIGHT / Number(canvas.height),
  };

  useEffect(() => {
    if (!ref?.current) return;

    drawShapes(shapes, ref.current, scale);
  }, [shapes]);

  return (
    <Box width={"100%"} height={"100%"}>
      <Box
        boxShadow="rgba(0, 0, 0, 0.1) 0px 4px 12px"
        marginBottom={2}
        width={"250px"}
        height={"200px"}
      >
        <svg
          ref={ref}
          style={{
            width: "100%",
            height: "100%",
            border: "1px solid black",
            userSelect: "none",
          }}
          viewBox="0 0 250 200"
          {...rest}
        ></svg>
      </Box>
      {!active && (
        <Typography variant="body2" className="canvas-name-text">
          {canvas.name ?? canvas.id}
        </Typography>
      )}
    </Box>
  );
};
